// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { connect } from 'react-redux';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Table } from 'react-bootstrap';
import Sorter from '../utils/Sorting/Sorter';
import '../../styles/components/UserList.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../infrastructure/utils/common';
import { getUserRoleLabel } from '../../infrastructure/utils/users';

import UsersMobileList from './UsersMobileList';

class UserList extends React.PureComponent {
  handleOnClick = event => {
    event.preventDefault();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleOnClick } = this.props;
    handleOnClick(event, event.currentTarget.getAttribute('href'));
  };

  changeSort = event => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { changeSort } = this.props;
    event.stopPropagation();
    event.preventDefault();
    changeSort(event.currentTarget.getAttribute('name'));
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { users, activeSort, deletedUser, handleOnClick } = this.props;
    if (isMobileResolution()) {
      return <UsersMobileList users={users} onClick={handleOnClick} />;
    }
    return (
      <div className='userlist'>
        <Table hover>
          <thead>
            <tr>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='name'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Name
                <Sorter activeSort={activeSort} name='name' />
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='email'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Email
                <Sorter activeSort={activeSort} name='email' />
              </th>
              <th>Role</th>
            </tr>
          </thead>
          <tbody>
            {users // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              .filter(us => us.id !== deletedUser)
              .map(user => (
                <tr
                  key={user.id}
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  href={`/users/${user.id}`}
                  className='listrow'
                  onClick={this.handleOnClick}
                >
                  <td style={{ width: '45%' }}>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{getUserRoleLabel(user.role)}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    deletedUser: state.users.deletedUser,
  };
}

export default connect(mapStateToProps)(UserList);
